import { makeStyles } from "@mui/styles";
export var useDisplayCardStyles = makeStyles(function (theme) { return ({
    root: {
        width: "233px",
        height: "112px",
        borderRadius: "20px",
    },
    content: {
        display: "flex",
        justifyContent: "space-between",
        color: theme.design.colors.waz_yellowsea,
        fontWeight: "bold",
    },
    pend: {
        fontSize: "18px",
        marginTop: theme.spacing(2),
    },
    icon: {
        color: theme.design.colors.gray60,
        fontSize: "25px",
        cursor: "pointer",
    },
}); });
